import * as React from 'react';
import {
  ThemeProvider,
  AddItem as WSRAddItem,
  AddItemSize as WSRAddItemSize,
} from 'wix-style-react-tpa';
import { theme } from './WSRTheme';

import { st, classes } from './AddItem.st.css';
import { DATA_HOOKS } from './constants';
import { TPAComponentsConsumer } from '../TPAComponentsConfig';
import {
  AddItemIconSize,
  AddItemAlignment,
  AddItemDirection,
  AddItemProps,
  AddItemDefaultProps,
} from './types';

const WSR_SIZE_MAP: Record<AddItemIconSize, WSRAddItemSize> = {
  [AddItemIconSize.small]: 'tiny',
  [AddItemIconSize.medium]: 'small',
  [AddItemIconSize.large]: 'medium',
  [AddItemIconSize.xLarge]: 'large',
};

/** Add Item is a component used to add new items to an existing items list. */
export class AddItem extends React.Component<AddItemProps> {
  static displayName = 'AddItem';
  static defaultProps: AddItemDefaultProps = {
    disabled: false,
    hasError: false,
    alignment: AddItemAlignment.center,
    direction: AddItemDirection.horizontal,
    iconSize: AddItemIconSize.medium,
  };

  render() {
    const {
      className,
      children,
      disabled,
      alignment,
      direction,
      iconSize,
      hasError,
      onClick,
      'aria-label': ariaLabel,
      'aria-labelledby': ariaLabelledBy,
    } = this.props;

    const rootClassName = st(classes.root, className);
    const noChildren = !children;

    return (
      <TPAComponentsConsumer>
        {({ rtl }) => (
          <ThemeProvider
            dataHook={this.props['data-hook']}
            theme={theme(rootClassName)}
          >
            <WSRAddItem
              className={st(
                classes.wsrAddItemRoot,
                { rtl, hasError, direction, noChildren },
                className,
              )}
              dataHook={DATA_HOOKS.ADD_ITEM}
              disabled={disabled}
              theme="dashes"
              alignItems={alignment}
              borderRadius="0"
              size={WSR_SIZE_MAP[iconSize]}
              onClick={onClick}
              ariaLabel={ariaLabel}
              ariaLabelledBy={ariaLabelledBy}
            >
              {() => (
                <div className={classes.text} data-hook={DATA_HOOKS.TEXT}>
                  {children}
                </div>
              )}
            </WSRAddItem>
          </ThemeProvider>
        )}
      </TPAComponentsConsumer>
    );
  }
}
